

//
// ************
//


// Get unique array items
Array.prototype.unique = function() {
  var a = this.concat();
  for(var i=0; i<a.length; ++i) {
      for(var j=i+1; j<a.length; ++j) {
          if(a[i] === a[j])
              a.splice(j--, 1);
      }
  }

  return a;
};


//
// ************
//


export default {
  // get: search string
  getSearchString: (str = null, encode = false) => {
    str = typeof str !== 'undefined' && str !== null ? str
      : window.location.search
    return !encode
      ? str
      : encodeURI(str)
  },

  // get: search string as object (string)
  // param string, clean, remove ?, split on &, split on = to get key/val, save in object.
  getSearchStringAsObject: (str = null) => {
    if (!str || str.length === 0 || str.indexOf('?') === -1)
      return {}
    //
    return str
      .trim()
      .replace(/\?/g, '')
      .split('&')
      .reduce((acc, param) => {
        param = param.split('=')
        acc[param[0]] = decodeURIComponent(param[1]).split(',')
        return acc
      }, {})
  },

  // get: search string from object (object)
  getSearchStringFromObject: (obj = {}) => {
    if (!obj || Object.keys(obj).length === 0)
      return '';
    //
    const searchString = Object
      .keys(obj)
      .reduce((acc, key) => {
        let value = obj[key];
            value = (typeof value.map !== 'function') ? value
              : value.join(',');
        acc.push(key + '=' + encodeURIComponent(value));
        return acc;
      }, [])
      .join('&');
    //
    return (searchString.length === 0) ? searchString
      : `?${ searchString }`;
  },

  // transform array items to integers
  stringArrToIntArr: (array) => {
    if (!array || array.length === 0) return []
    //
    const cleanedArray = []
    array.map((item) => {
      cleanedArray.push(parseInt(item))
    })

    return cleanedArray
  },

  checkForSlashAtEnd: path => {
    if (path.slice(-1) === "/") {
      return path
    } else {
      return (path + "/")
    }
  },

  getTypedValue: function (value) {
    function toArray(values, toInt) {
      let array = []
      values.split(",").forEach(function(item) {
        // trim starting and ending single quote
        item = item.replace(/^'?([^'|$]+)'?$/,"$1")
        // parse to int if we want that
        if(toInt)
          item = parseInt(item)
        array.push(item)
      })
      return array
    }

    if(value === undefined || value === null)
      return null

    // if empty array return null
    if(value == '[]' || (Array.isArray(value) && value.length < 1))
      return null

    // match int array in string value
    let match = /^\[((?:\d+,?)+)/.exec(value)
    if(match != null)
      return toArray(match[1], true)

    // match string array in string value
    match = /\[((?:(?:[^,]+),?)+)]/.exec(value)
    if(match != null)
      return toArray(match[1], false)

    if (typeof value === "boolean")
      return value

    if(isNaN(value) === false)
      return parseInt(value)

    return value
  }
}
